import React, { useEffect, useState } from "react";
import { Autocomplete, Skeleton, TextField } from "@mui/material";

export default function ProductSelection({ value, onChange }) {
    const [products, setProducts] = useState(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        fetch("api/products?onlyActiveProducts=true")
            .then((res) => res.json())
            .then((data) => {
                setProducts(data);
                setIsReady(true);
            });
    }, []);

    if (!isReady) {
        return <Skeleton variant="rectangular" width={350} height={50} />;
    }

    return (
        <Autocomplete
            disablePortal
            id="combo-box-sku"
            getOptionLabel={(option) => `${option.sku} - ${option.description}`}
            isOptionEqualToValue={(option, value) => option.sku === value.sku}
            options={products || []}
            sx={{ width: 350 }}
            renderInput={(params) => (
                <TextField {...params} label="Select a SKU" />
            )}
            value={value || null}
            onChange={onChange}
        />
    );
}
